<template>
  <div class="container-desktop">
    <img
      alt="WhatsApp logo"
      src="@/assets/WhatsApp_logo.png"
      class="logo-desktop"
      v-if="isLoadingDone"
    />
  </div>
  <div class="tenantLogoContainer">
    <img
      :src="logoPath + logoGuid"
      class="tenantLogo"
      alt="Logo"
      v-if="logoGuid"
    />
  </div>
  <div class="qr-code-container">
    <div class="qr-code-wrapper" v-if="isLoadingDone">
      <div>
        <img :src="qrCodeUrl" alt="QR Code" class="qr-code-image" />
      </div>
      <div class="scan-text">scan to start</div>
      <button class="button-desktop" v-if="isLoadingDone" @click="openUrl">
        or use WhatsApp Desktop client
      </button>
    </div>
  </div>

  <div class="container-footer-desktop" @click="openPitchYouTab">
    <div class="powered-by-text" v-if="isLoadingDone">powered by</div>
    <img
      v-if="isLoadingDone"
      alt="Powered by PitchYou"
      src="@/assets/pitchyou_logo.png"
      class="footer-logo-desktop"
    />
  </div>
</template>

<script lang="ts">
import QRCode from 'qrcode';
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    isLoadingDone: Boolean,
    buttonUrl: String,
    logoGuid: String,
  },
  methods: {
    openPitchYouTab() {
      const url = 'https://www.pitchyou.de'; // URL, die geöffnet werden soll
      window.open(url, '_blank');
    },
  },
  setup(props) {
    const targetUrl = ref('');
    const useWindowOpen = ref(true);
    const qrCodeUrl = ref('');
    const logoPath = ref('/api/media/v1/logo/');

    const openUrl = () => {
      if (props.buttonUrl) {
        if (useWindowOpen.value) {
          window.open(props.buttonUrl, '_blank');
        } else {
          window.location.href = props.buttonUrl;
        }
        useWindowOpen.value = !useWindowOpen.value;
      }
    };

    const generateQRCode = async () => {
      if (props.buttonUrl) {
        try {
          const url = await QRCode.toDataURL(props.buttonUrl, {
            color: { dark: '#000', light: '#fcf5eb' },
            width: 250,
            margin: 2,
          });
          qrCodeUrl.value = url;
        } catch (error) {
          console.error('Fehler beim Generieren des QR-Codes:', error);
        }
      }
    };

    watch(
      () => props.buttonUrl,
      (newButtonUrl) => {
        targetUrl.value = newButtonUrl ?? '';
      }
    );

    watch(
      () => props.buttonUrl,
      (newVal) => {
        if (newVal) {
          generateQRCode();
        }
      },
      { immediate: true }
    );

    return {
      openUrl,
      targetUrl,
      qrCodeUrl,
      logoPath,
    };
  },
});
</script>
<style>
body,
html {
  height: 100%; /* Stellt sicher, dass der HTML- und Body-Tag den gesamten Viewport einnehmen */
  margin: 0; /* Entfernt Standardmargins */
  display: flex;
  flex-direction: column;
}

body {
  font-family: Verdana, Geneva, Tahoma, sans-serif, sans-serif;
}

.container-desktop {
  background-color: #fcf5eb;
  height: 15vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin: 0;
  flex: 1 0 auto;
}

.container-footer-desktop {
  background-color: #fcf5eb;
  height: 5vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 0;
  margin: 0;
  margin-top: auto;
  padding-bottom: 10px;
  cursor: pointer;
}
.container-footer-desktop div {
  margin-right: 10px; /* Abstand zwischen Text und Logo */
  margin-bottom: 20px; /* Abstand vom unteren Rand */
}

.footer-logo-desktop {
  max-width: 100px; /* Passen Sie die Größe nach Bedarf an */
  margin-top: auto; /* Schiebt das Logo an den unteren Rand */
}

.powered-by-text {
  color: #25d366; /* Farbe für 'powered by' Text */
}

.logo-desktop {
  max-width: 10%;
  margin: 30px auto 0;
  display: block;
}

.qr-code-container {
  background-color: #fcf5eb;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 67vh;
  min-height: 67vh;
  flex-direction: column;
}

.qr-code-wrapper {
  /* Rahmen um den QR-Code */
  border-radius: 10px; /* Eckenabrundung */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Schatten */

  /* Zentrierung und Größenanpassung */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px; /* Innenabstand */
  margin: 5px;
  flex-direction: column;
}

.button-desktop {
  /* Größere Schriftgröße und größere Abmessungen für den Button */
  font-size: 0.8em;

  /* Leicht abgerundete Ecken */
  border-radius: 10px; /* Ändern Sie den Wert für stärker oder schwächer abgerundete Ecken */

  /* Entfernen des Rahmens */
  border: none;

  /* Optional: Hintergrundfarbe und Textfarbe */
  color: #25d366; /* Blauer Hintergrund */
  background-color: #fcf5eb; /* Weißer Text */

  /* Weitere Stilisierung */
  cursor: pointer;

  text-decoration: underline;

  &:hover {
    color: #551a8b; /* Farbänderung beim Überfahren mit der Maus */
  }
}

.scan-text {
  width: 80%;
  /* Setzen Sie einen Abstand zu den Seiten */
  margin: 20px;
  /* Größere Schriftgröße und größere Abmessungen für den Button */
  font-size: 1em;
  padding: 10px 20px; /* Ändern Sie die Werte nach Bedarf */

  /* Abstand nach oben */
  margin-top: 20px; /* Ändern Sie den Wert nach Bedarf */

  /* Leicht abgerundete Ecken */
  border-radius: 10px; /* Ändern Sie den Wert für stärker oder schwächer abgerundete Ecken */

  /* Entfernen des Rahmens */
  border: none;

  /* Optional: Hintergrundfarbe und Textfarbe */
  background-color: #25d366; /* Blauer Hintergrund */
  color: #fcf5eb; /* Weißer Text */

  /* Weitere Stilisierung */
  transition: background-color 0.3s;

  text-align: center;
}

.tenantLogoContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fcf5eb;
  padding-bottom: 20px;
  max-height: 10vh;
  min-height: 10vh;
}
.tenantLogo {
  max-width: 120px;
  max-height: 100px;
  object-fit: contain;
  width: auto;
  height: auto;
  display: block;
}
</style>
